<script>
export default {
  name: 'SocialDiscord',
  props: {
    url: String,
  },
};
</script>

<template>
  <a :href="url" target="_blank">
    <svg class="ico"><use xlink:href="#ico-discord"></use></svg>
  </a>
</template>

<style scoped lang="scss"></style>
